import { render, staticRenderFns } from "./UserPageSelector.vue?vue&type=template&id=15da32f6&"
import script from "./UserPageSelector.vue?vue&type=script&lang=ts&"
export * from "./UserPageSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports